import { AxiosPromise } from 'axios'
import { createLogoutClient } from './createLogoutClient'
import { logout } from './methods'
import { LogoutClient as BaseLogoutClient } from './types'
import { LogoutClientOptions } from './types/LogoutClient'

export default function LogoutClient(options?: LogoutClientOptions): LogoutClient {
  const commonOptions = {}

  return createLogoutClient({
    ...commonOptions,
    ...options,
    methods: {
      logout,
    },
  })
}

export type LogoutClient = BaseLogoutClient & {
  readonly logout: () => AxiosPromise<any>
}
